package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/lion-king". Pulls the REAL cached analysis from PROD. */
@Page("/isitsafe/lion-king")
@Composable
fun LionKingReviewPage() {
    PublicReviewPage(
        slug = "lion-king",
        blurb = "Is The Lion King OK for Muslim kids? Here's the full Fitrah Filter breakdown: themes, concerns, and what parents should know before watching.",
    )
}
